(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bam-tee-pair"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bam-tee-pair')) return;
  class BamTeePair extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-pair-config]');
      if (!config) return;
      try { this.config = JSON.parse(config.textContent); } catch (_) { return; }
      this.scope = this.closest('[data-section-type="product-section"]');
      if (!this.scope) return;
      this.primary = this.config.primary;
      this.words = this.config.text;
      if (!this.words || typeof this.words !== 'object') return;
      const ids = new Set([this.primary.id]);
      const embedded=(this.config.catalogue?.products || []).filter(Boolean);
      this.products = [...(this.config.products || []),...embedded].filter(p => {
        if (!p || ids.has(p.id) || !p.image || !p.variants.some(v => v.available)) return false;
        ids.add(p.id); return true;
      }).slice(0,8);
      if (!this.products.length && this.primary.variants.some(v=>v.available)) this.products=[this.primary];
      if (!this.products.length) return;
      this.ready = true;
      this.primaryVariant = this.primary.variants.find(v => v.id === this.config.selected) || this.primary.variants[0];
      const pairs = {
        'halloween-dont-go-to-hospital-short-sleeve-t-shirt':'never-enjoy-halloween-short-sleeve-t-shirt',
        'never-enjoy-halloween-short-sleeve-t-shirt':'never-enjoy-anything-limited-edition-tshirt',
        'never-enjoy-anything-limited-edition-tshirt':'halloween-dont-go-to-hospital-short-sleeve-t-shirt'
      };
      this.partner = this.products.find(p => p.handle === pairs[this.primary.handle]) || this.products[0];
      this.catalogue=new Map([this.primary,...this.products,...embedded].map(product=>[product.id,product]));
      this.catalogueNext=this.config.catalogueUrl;
      this.catalogueFallback=false;
      this.catalogueComplete=!!this.config.catalogue?.complete;
      this.catalogueLoading=false;
      this.catalogueError=false;
      this.pickerVariants=new Map();
      this.pickerSlot=2;
      this.modeCount=2;
      this.third=null;
      this.thirdVariant=null;
      this.dialog=this.querySelector('[data-pair-picker]');
      this.matchSize = true;
      this.busy = false;
      this.uncertain = false;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.singleButton = this.scope.querySelector('.product__section-content__block--buttons .js-ajax-submit');
      this.singleForm = this.singleButton?.closest('form');
      if (this.hasAttribute('data-pair-stacked-controls') && this.singleForm && !this.contains(this.singleForm)) {
        this.singleFormPlaceholder = document.createComment('');
        this.singleForm.before(this.singleFormPlaceholder);
        this.querySelector('[data-pair-add]').after(this.singleForm);
        this.classList.add('bam-pair--stacked-controls');
      }
      this.scope.classList.add('bam-pair-ready');
      this.scope.querySelectorAll('[name="quantity"]').forEach(input => { input.value = '1'; });
      this.addEventListener('click', e => this.onClick(e), opts);
      this.dialog.addEventListener('cancel',e=>{ if (this.busy) e.preventDefault(); },opts);
      this.dialog.addEventListener('close',()=>this.restorePickerPage(),opts);
      this.dialog.addEventListener('click',e=>{
        if (e.target!==this.dialog) return;
        const bounds=this.dialog.getBoundingClientRect();
        if (e.clientX<bounds.left || e.clientX>bounds.right || e.clientY<bounds.top || e.clientY>bounds.bottom) this.closePicker();
      },opts);
      this.querySelector('[data-picker-search]').addEventListener('input',()=>{
        clearTimeout(this.searchTimer);
        this.searchTimer=setTimeout(()=>this.renderCatalogue(),120);
      },opts);
      this.dialog.addEventListener('change',e=>{
        if (!e.target.matches('[data-picker-variant]')) return;
        this.pickerVariants.set(`${this.pickerSlot}:${e.target.dataset.pickerVariant}`,e.target.value);
        this.updateCardSelections();
      },opts);
      this.scope.addEventListener('change', e => {
        if (this.contains(e.target)) return;
        if (e.target.matches('.formVariantId, .js-qty-input') || e.target.closest('.js-variant-selector')) {
          queueMicrotask(() => this.syncPrimary());
        }
      }, opts);
      this.scope.addEventListener('click', e => {
        if (e.target.closest('.js-variant-selector')) queueMicrotask(() => this.syncPrimary());
      }, opts);
      this.scope.addEventListener('click', e => {
        if (!e.target.closest('.js-ajax-submit')) return;
        if (this.busy || this.uncertain) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, {capture:true, signal:this.abort.signal});
      window.addEventListener('popstate', () => this.syncPrimary(), opts);
      this.hidden = false;
      this.renderPartner();
      this.syncPrimary();
      this.setupSticky();
    }
    disconnectedCallback() {
      this.closePicker(true); clearTimeout(this.searchTimer);
      this.abort?.abort(); this.observer?.disconnect();
      if (this.singleFormPlaceholder?.parentNode && this.singleForm) this.singleFormPlaceholder.replaceWith(this.singleForm);
      this.singleFormPlaceholder = null;
      this.classList.remove('bam-pair--stacked-controls');
      this.scope?.classList.remove('bam-pair-ready');
      document.body.classList.remove('bam-pair-mobile-space');
      this.ready = false;
    }
    t(key, replacements = {}) {
      return Object.entries(replacements).reduce((s,[k,v]) => s.replaceAll(`{${k}}`,v), this.words[key] || key);
    }
    money(cents, compact = false) {
      return new Intl.NumberFormat(this.config.locale || 'en-US',{style:'currency',currency:this.config.currency,...(compact ? {minimumFractionDigits:cents%100===0 ? 0 : 2,maximumFractionDigits:2} : {})}).format(cents/100);
    }
    discountCents(count=2) {
      const amount=Number(count===3 ? this.config.tripleDiscountAmount : this.config.discountAmount);
      const active=count===3 ? this.config.tripleActive : this.config.discountActive;
      if (!active || !Number.isFinite(amount) || amount<=0) return 0;
      if (this.config.currency===this.config.shopCurrency) return Math.round(amount);
      const currency=window.Shopify?.currency;
      const rate=Number(currency?.rate);
      return currency?.active===this.config.currency && Number.isFinite(rate) && rate>0 ? Math.round(amount*rate) : 0;
    }
    put(selector, value) { const el = this.querySelector(selector); if (el) el.textContent = value; }
    sizeOf(product, variant) {
      const i = product.options.findIndex(name => /^(size|sizes)$/i.test(name));
      return i >= 0 && variant ? variant.options[i] : null;
    }
    matchVariant(product=this.partner) {
      const size = this.sizeOf(this.primary,this.primaryVariant);
      const sizeIndex = product.options.findIndex(name => /^(size|sizes)$/i.test(name));
      const pool = product.variants.filter(v => v.available && (sizeIndex < 0 || !size || v.options[sizeIndex] === size));
      const colorIndex = product.options.findIndex(name => /^(color|colour)$/i.test(name));
      return pool.find(v => colorIndex >= 0 && /^black$/i.test(v.options[colorIndex])) || pool[0] || null;
    }
    syncPrimary() {
      const groups = [...this.scope.querySelectorAll('.js-variant-selector')];
      let options = groups.map(g => g.tagName === 'SELECT' ? g.value : g.querySelector('input:checked')?.value);
      if (options.length) this.primaryVariant = this.primary.variants.find(v => v.options.every((o,i) => o === options[i])) || null;
      else {
        const id = this.scope.querySelector('.formVariantId')?.value || this.config.selected;
        this.primaryVariant = this.primary.variants.find(v => String(v.id) === String(id)) || null;
      }
      this.put('[data-pair-first-size]', this.primaryVariant?.title === 'Default Title' ? '' : this.primaryVariant?.title || this.t('unavailable'));
      if (this.matchSize) this.partnerVariant = this.matchVariant();
      this.renderPrices();
    }
    renderPartner() {
      this.put('[data-pair-title]',this.partner.title);
      const image = this.querySelector('[data-pair-image]');
      image.src = this.partner.image; image.alt = this.partner.title;
      if (this.matchSize || !this.partner.variants.some(v=>v.id===this.partnerVariant?.id)) this.partnerVariant = this.matchVariant();
      if (!this.matchSize && !this.partnerVariant) this.partnerVariant = this.partner.variants.find(v => v.available) || null;
      this.renderPrices();
    }
    priceOf(product,variant) {
      if (variant) return variant.price;
      const available=product?.variants.filter(item=>item.available).map(item=>item.price) || [];
      return available.length ? Math.min(...available) : product?.variants[0]?.price || 0;
    }
    renderPrices() {
      const first=this.primaryVariant,second=this.partnerVariant,bundle=this.bundle();
      const pairBase=this.priceOf(this.primary,first)+this.priceOf(this.partner,second);
      const pairSaving=Math.min(pairBase,this.discountCents(2)),pairTotal=pairBase-pairSaving;
      const pairPercent=pairBase ? Math.floor(pairSaving*100/pairBase) : 0;
      const quote=this.thirdQuote();
      const selectedTotal=this.modeCount===3 ? quote?.total : pairTotal;
      this.classList.toggle('bam-pair--three',this.modeCount===3);
      this.put('[data-pair-tier-two-price]',this.money(pairTotal,true));
      this.put('[data-pair-tier-two-saving]',pairSaving ? this.t('bundle_save',{percent:pairPercent}) : '');
      this.querySelector('[data-pair-tier="3"]').hidden=!this.config.tripleActive;
      if (quote) {
        this.put('[data-pair-tier-three-price]',quote.from ? this.t('bundle_from',{price:this.money(quote.total,true)}) : this.money(quote.total,true));
        this.put('[data-pair-tier-three-saving]',quote.saving ? this.t('bundle_save',{percent:quote.percent}) : '');
      }
      this.querySelector('[data-pair-best]').hidden=!quote || quote.total/3>=pairTotal/2;
      this.querySelectorAll('[data-pair-tier]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.pairTier)===this.modeCount)));
      this.put('[data-pair-first-size]',first?.title==='Default Title' ? '' : first?.title || this.t('choose_size'));
      this.put('[data-pair-second-size]',second?.title==='Default Title' ? '' : second?.title || this.t('choose_size'));
      const missingMatch=this.matchSize && !second && !!first?.available;
      this.querySelector('[data-pair-notice]').hidden=!missingMatch;
      this.put('[data-pair-notice]',this.t('size_missing',{size:this.sizeOf(this.primary,first) || ''}));
      this.put('[data-pair-price]',selectedTotal!=null ? this.money(selectedTotal) : this.t('choose_size'));
      this.put('[data-pair-was]',this.money(bundle.base)); this.querySelector('[data-pair-was]').hidden=!bundle.saving || !bundle.valid;
      this.put('[data-pair-browse]',this.t('bundle_browse',{count:this.catalogue.size})+' →');
      this.renderThird();
      const button=this.querySelector('[data-pair-add]');
      button.disabled=!first?.available || this.busy || this.uncertain;
      button.textContent=this.buttonText(bundle);
      if (this.singleButton) {
        this.singleButton.disabled=this.busy || this.uncertain || !first?.available;
        this.singleButton.value=first?.available ? this.t('just_one',{price:this.money(first.price)}) : this.t('sold_out');
      }
      this.put('[data-pair-sticky-count]',this.t(this.modeCount===3 ? 'three_tees' : 'two_tees'));
      this.put('[data-pair-sticky-price]',selectedTotal!=null ? `· ${this.money(selectedTotal)}` : '');
      this.put('[data-pair-sticky-detail]',bundle.saving ? this.t(bundle.shipping ? 'sticky_offer_shipping' : 'sticky_offer',{saving:this.money(bundle.saving)}) : this.t('swap_anytime'));
      this.querySelector('[data-pair-jump]').disabled=this.busy || this.uncertain;
      this.renderPickerSummary(bundle);
    }
    onClick(event) {
      const button=event.target.closest('button'); if (!button || !this.contains(button) || button.disabled) return;
      if (this.busy || this.uncertain && !button.hasAttribute('data-picker-close')) return;
      if (button.hasAttribute('data-pair-add')) { event.preventDefault(); this.addPair(); }
      if (button.hasAttribute('data-pair-edit-primary')) {
        const group=this.scope.querySelector('.js-variant-selector');
        const control=group?.matches('select') ? group : group?.querySelector('input:checked,button,select,input');
        group?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
        control?.focus({preventScroll:true});
      }
      if (button.hasAttribute('data-pair-swap') || button.hasAttribute('data-pair-browse')) this.openPicker(2,button);
      if (button.hasAttribute('data-pair-open-third')) this.openPicker(3,button);
      if (button.dataset.pairTier) {
        if (button.dataset.pairTier==='2') {
          this.modeCount=2;this.third=null;this.thirdVariant=null;this.renderPrices();
        } else this.openPicker(3,button);
      }
      if (button.hasAttribute('data-picker-close')) this.closePicker();
      if (button.hasAttribute('data-picker-retry')) this.loadCatalogue();
      if (button.hasAttribute('data-picker-add')) this.addPair();
      if (button.hasAttribute('data-picker-clear')) {
        this.querySelector('[data-picker-search]').value='';this.renderCatalogue();this.querySelector('[data-picker-search]').focus();
      }
      if (button.dataset.pickerChoose) this.chooseFromCatalogue(button.dataset.pickerChoose);
      if (button.dataset.pickerSlot) {
        this.pickerSlot=Number(button.dataset.pickerSlot);
        if (this.pickerSlot===3) this.modeCount=3;
        this.querySelector('[data-picker-search]').value='';
        this.renderPrices();this.renderCatalogue();
        this.querySelector('[data-picker-results]').scrollTop=0;
      }
      if (button.hasAttribute('data-pair-jump')) {
        this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        this.querySelector('[data-pair-add]').focus({preventScroll:true});
      }
    }
    bundle() {
      const entries=[{product:this.primary,variant:this.primaryVariant},{product:this.partner,variant:this.partnerVariant}];
      if (this.modeCount===3) entries.push({product:this.third,variant:this.thirdVariant});
      const valid=entries.every(entry=>entry.variant?.available);
      const base=entries.reduce((sum,entry)=>sum+(entry.variant?.price || 0),0);
      const saving=valid ? Math.min(base,this.discountCents(entries.length)) : 0;
      const total=base-saving;
      return {entries,count:entries.length,valid,base,saving,total,percent:base ? (entries.length===3 ? Math.round(saving*100/base) : Math.floor(saving*100/base)) : 0,shipping:this.qualifiesForShipping(total,valid)};
    }
    qualifiesForShipping(total,valid=true) {
      return valid && this.config.country==='US' && this.config.currency==='USD' && total>=this.config.shippingThreshold;
    }
    thirdQuote() {
      if (!this.config.tripleActive) return null;
      const prices=[...this.catalogue.values()].flatMap(product=>product.variants.filter(variant=>variant.available).map(variant=>variant.price));
      if (!prices.length) return null;
      const thirdPrice=this.thirdVariant?.price ?? Math.min(...prices);
      const pairBase=this.priceOf(this.primary,this.primaryVariant)+this.priceOf(this.partner,this.partnerVariant);
      const base=pairBase+thirdPrice,saving=Math.min(base,this.discountCents(3));
      const total=base-saving;
      const pairTotal=Math.max(0,pairBase-this.discountCents(2));
      return {total,base,saving,percent:base ? Math.round(saving*100/base) : 0,increment:Math.max(0,total-pairTotal),shipping:this.qualifiesForShipping(total),from:!this.thirdVariant && new Set(prices).size>1};
    }
    buttonText(bundle) {
      if (this.busy) return this.t('adding');
      if (this.uncertain) return this.t('review_cart');
      if (!this.primaryVariant?.available) return this.t('unavailable');
      if (!this.partnerVariant?.available) return this.t('choose_second_size');
      if (this.modeCount===3 && !this.thirdVariant?.available) return this.t('bundle_choose_third');
      const offer=bundle.saving>0 && bundle.percent>0;
      const key=bundle.count===3 ? (offer ? (bundle.shipping ? 'add_three_offer_shipping' : 'add_three_offer') : (bundle.shipping ? 'add_three_shipping' : 'add_three')) : offer ? (bundle.shipping ? 'add_both_offer_shipping' : 'add_both_offer') : (bundle.shipping ? 'add_both_shipping' : 'add_both');
      return this.t(key,{percent:bundle.percent,price:this.money(bundle.total,true)});
    }
    renderThird() {
      const row=this.querySelector('[data-pair-third]');row.hidden=this.modeCount!==3;
      row.classList.toggle('bam-pair__tile--empty',!this.third);
      this.querySelector('[data-pair-third-placeholder]').hidden=!!this.third;
      const image=this.querySelector('[data-pair-third-image]');image.hidden=!this.third?.image;
      if (this.third?.image) image.src=this.third.image;
      image.alt=this.third?.title || '';
      this.put('[data-pair-third-title]',this.third?.title || this.t('bundle_choose'));
      this.put('[data-pair-third-variant]',this.thirdVariant?.title || '');
      this.put('[data-pair-third-action]',this.t(this.third ? 'bundle_change' : 'bundle_choose'));
    }
    openPicker(slot,opener) {
      if (this.busy || this.uncertain || typeof this.dialog.showModal!=='function') return;
      this.syncPrimary();
      this.pickerSlot=slot===3 && this.config.tripleActive ? 3 : 2;
      if (this.pickerSlot===3) this.modeCount=3;
      this.renderPrices();
      this.pickerOpener=opener;
      this.querySelector('[data-picker-search]').value='';
      this.renderCatalogue();
      this.renderPickerSummary(this.bundle());
      this.dialog.showModal();
      this.savedScroll=window.scrollY;
      this.savedBodyStyle={};
      ['position','top','left','right','width','overflow'].forEach(property=>{
        this.savedBodyStyle[property]={value:document.body.style.getPropertyValue(property),priority:document.body.style.getPropertyPriority(property)};
      });
      Object.assign(document.body.style,{position:'fixed',top:`-${this.savedScroll}px`,left:'0',right:'0',width:'100%',overflow:'hidden'});
      this.querySelector('[data-pair-sticky]').hidden=true;
      document.body.classList.remove('bam-pair-mobile-space');
      this.querySelector('[data-picker-close]').focus({preventScroll:true});
      this.loadCatalogue();
    }
    closePicker(force=false) {
      if (this.busy && !force) return;
      if (this.dialog?.open) this.dialog.close();
      this.restorePickerPage();
    }
    restorePickerPage() {
      if (!this.savedBodyStyle) return;
      Object.entries(this.savedBodyStyle).forEach(([property,style])=>{
        if (style.value) document.body.style.setProperty(property,style.value,style.priority);
        else document.body.style.removeProperty(property);
      });
      this.savedBodyStyle=null;
      window.scrollTo({top:this.savedScroll,left:0,behavior:'instant'});
      if (this.pickerOpener?.isConnected) this.pickerOpener.focus({preventScroll:true});
    }
    renderPickerSummary(bundle) {
      this.querySelectorAll('[data-picker-slot]').forEach(button=>{
        button.setAttribute('aria-pressed',String(Number(button.dataset.pickerSlot)===this.pickerSlot));
        button.hidden=button.dataset.pickerSlot==='3' && !this.config.tripleActive;
      });
      this.put('[data-picker-step]',this.t(this.pickerSlot===3 ? 'picker_third' : 'picker_second'));
      this.put('[data-picker-count]',this.t('picker_total',{count:bundle.count}));
      const quote=this.modeCount===3 && !bundle.valid ? this.thirdQuote() : null;
      this.put('[data-picker-total]',bundle.valid ? this.money(bundle.total) : quote ? this.money(quote.total) : this.t('choose_size'));
      this.put('[data-picker-saving]',bundle.saving ? this.t('bundle_save',{percent:bundle.percent}) : '');
      const button=this.querySelector('[data-picker-add]');
      button.textContent=this.buttonText(bundle);button.disabled=!bundle.valid || this.busy || this.uncertain;
      this.updateCardSelections();
    }
    pickerVariant(product) {
      const id=this.pickerVariants.get(`${this.pickerSlot}:${product.id}`);
      const selectedProduct=this.pickerSlot===3 ? this.third : this.partner;
      const selectedVariant=this.pickerSlot===3 ? this.thirdVariant : this.partnerVariant;
      return product.variants.find(variant=>String(variant.id)===String(id) && variant.available) || (selectedProduct?.id===product.id && selectedVariant?.available ? selectedVariant : null) || this.matchVariant(product) || product.variants.find(variant=>variant.available) || null;
    }
    renderCatalogue(append=false) {
      const grid=this.querySelector('[data-picker-grid]');
      if (!append) grid.replaceChildren();
      const query=this.querySelector('[data-picker-search]').value.trim().toLocaleLowerCase();
      const shown=new Set([...grid.children].map(card=>card.dataset.pickerCard));
      const products=[...this.catalogue.values()].filter(product=>product.title.toLocaleLowerCase().includes(query));
      const fragment=document.createDocumentFragment();
      products.forEach(product=>{
        if (shown.has(String(product.id))) return;
        const card=document.createElement('article'); card.className='bam-picker__card'; card.dataset.pickerCard=String(product.id);
        if (product.image) {
          const img=document.createElement('img'); img.src=product.image; img.alt=product.title; img.width=240; img.height=240; img.loading='lazy'; card.append(img);
        }
        const title=document.createElement('h4'); title.textContent=product.title;
        const label=document.createElement('label');
        const labelText=document.createElement('span'); labelText.className='bam-picker__sr'; labelText.textContent=this.t('picker_variant',{title:product.title});
        const select=document.createElement('select'); select.dataset.pickerVariant=String(product.id);
        select.add(new Option(this.t('choose_size'),''));
        product.variants.forEach(variant=>{
          const option=new Option(variant.title+(!variant.available ? ` — ${this.t('sold_out')}` : ''),variant.id);
          option.disabled=!variant.available; select.add(option);
        });
        const selected=this.pickerVariant(product); select.value=selected ? String(selected.id) : '';
        label.append(labelText,select);
        const choose=document.createElement('button'); choose.type='button'; choose.className='bam-picker__choose'; choose.dataset.pickerChoose=String(product.id); choose.textContent=this.t('picker_choose'); choose.disabled=!selected;
        card.append(title,label,choose); fragment.append(card);
      });
      grid.append(fragment);
      this.querySelector('[data-picker-empty]').hidden=!!products.length || this.catalogueLoading;
      this.put('[data-picker-load]',this.catalogueLoading ? this.t('picker_loading') : this.catalogueError ? this.t('picker_error') : this.t('picker_count',{count:products.length,total:this.catalogue.size}));
      this.querySelector('[data-picker-retry]').hidden=!this.catalogueError;
      this.querySelector('[data-picker-collection]').hidden=!this.catalogueError;
      this.querySelector('[data-picker-clear]').hidden=!query;
      this.updateCardSelections();
    }
    updateCardSelections() {
      const product=this.pickerSlot===3 ? this.third : this.partner;
      const variant=this.pickerSlot===3 ? this.thirdVariant : this.partnerVariant;
      this.querySelectorAll('[data-picker-card]').forEach(card=>{
        const selected=String(product?.id)===card.dataset.pickerCard && String(variant?.id)===card.querySelector('select').value;
        card.classList.toggle('is-selected',selected);
        const button=card.querySelector('button');
        button.setAttribute('aria-pressed',String(selected));
        const available=this.catalogue.get(Number(card.dataset.pickerCard))?.variants.some(item=>item.available);
        button.textContent=this.t(!available ? 'sold_out' : selected ? 'picker_selected' : 'picker_choose');
        button.disabled=this.busy || this.uncertain || !card.querySelector('select').value;
      });
    }
    catalogueUrl(value) {
      const url=new URL(value,window.location.href);
      if (url.origin!==window.location.origin) throw new Error('Invalid catalogue origin');
      const previewTheme=new URL(window.location.href).searchParams.get('preview_theme_id') || (this.config.themeRole && this.config.themeRole!=='main' ? this.config.themeId : null);
      if (previewTheme) url.searchParams.set('preview_theme_id',previewTheme);
      return url;
    }
    async fetchCataloguePage(url) {
      const controller=new AbortController();
      const abort=()=>controller.abort(); this.abort.signal.addEventListener('abort',abort,{once:true});
      const timeout=setTimeout(abort,15000);
      try {
        const response=await fetch(url.href,{credentials:'same-origin',headers:{Accept:'application/json'},signal:controller.signal});
        if (!response.ok) throw new Error('Catalogue unavailable');
        const data=await response.json();
        if (!Array.isArray(data.products)) throw new Error('Invalid catalogue');
        return data;
      } finally { clearTimeout(timeout); this.abort.signal.removeEventListener('abort',abort); }
    }
    normalizeCatalogue(data) {
      const products=data.products.filter(Boolean).map(product=>{
        if (!this.catalogueFallback) return product;
        return {id:product.id,handle:product.handle,title:product.title,image:product.images?.[0] || null,options:product.options,variants:(product.variants || []).map(variant=>({id:variant[0],price:variant[1],available:variant[2],options:variant[3],title:Array.isArray(variant[3]) ? variant[3].join(' / ') : ''}))};
      });
      if (data.currency && data.currency!==this.config.currency) throw new Error('Catalogue context mismatch');
      if (!data.currency) {
        if (!this.catalogueFallback) throw new Error('Catalogue currency missing');
        const verified=products.some(product=>{
          const reference=this.catalogue.get(product.id);
          return reference?.variants.some(known=>product.variants.some(variant=>known.id===variant.id && known.price===variant.price));
        });
        if (!this.catalogueContextVerified && !verified) throw new Error('Catalogue prices could not be verified');
        this.catalogueContextVerified=true;
      }
      return products;
    }
    async loadCatalogue() {
      if (this.catalogueLoading || this.catalogueComplete) return;
      this.catalogueLoading=true; this.catalogueError=false;
      this.renderCatalogue(true);
      try {
        let requests=0;
        while (this.catalogueNext && !this.abort.signal.aborted && requests++<100) {
          const url=this.catalogueUrl(this.catalogueNext);
          url.searchParams.set('view',this.catalogueFallback ? 'bam-bundle-data' : 'bam-tee-picker');
          let data;
          try {
            data=await this.fetchCataloguePage(url);
          } catch (error) {
            if (this.abort.signal.aborted || this.catalogueFallback || !this.config.catalogueFallbackUrl) throw error;
            this.catalogueFallback=true;
            this.catalogueNext=this.config.catalogueFallbackUrl;
            continue;
          }
          this.normalizeCatalogue(data).forEach(product=>{
            if (Number.isFinite(product.id) && typeof product.title==='string' && Array.isArray(product.options) && Array.isArray(product.variants) && product.variants.length) this.catalogue.set(product.id,product);
          });
          let next=data.next ? new URL(data.next,url.href) : null;
          if (!next && Number(data.page)<Number(data.pages)) {
            next=new URL(url.href); next.searchParams.set('page',String(Number(data.page)+1));
          }
          if (next) {
            next.searchParams.set('view',this.catalogueFallback ? 'bam-bundle-data' : 'bam-tee-picker');
            if (next.href===url.href) throw new Error('Repeated catalogue page');
          }
          this.catalogueNext=next?.href || null;
          this.renderCatalogue(true);
          this.renderPrices();
        }
        if (this.catalogueNext) throw new Error('Catalogue incomplete');
        this.catalogueComplete=true;
      } catch (_) {
        if (!this.abort.signal.aborted) this.catalogueError=true;
      } finally {
        this.catalogueLoading=false;
        if (!this.abort.signal.aborted) this.renderCatalogue(true);
      }
    }
    chooseFromCatalogue(id) {
      if (this.busy || this.uncertain) return;
      const product=this.catalogue.get(Number(id));
      const select=this.querySelector(`[data-picker-variant="${Number(id)}"]`);
      const variant=product?.variants.find(item=>String(item.id)===select?.value && item.available);
      if (!variant) return;
      if (this.pickerSlot===3) {
        this.modeCount=3;this.third=product;this.thirdVariant=variant;
      } else {
        this.partner=product; this.partnerVariant=variant; this.matchSize=false; this.renderPartner();
      }
      this.renderPrices();
      this.put('[data-picker-announcement]',this.t('picker_selection',{slot:this.t(this.pickerSlot===3 ? 'third_tee' : 'second_tee'),title:product.title,variant:variant.title}));
      this.closePicker();
    }
    status(message, review=false) {
      const status=this.querySelector('[data-pair-status]'); status.hidden=!message; status.textContent=message;
      this.querySelector('[data-pair-review]').hidden=!review;
      this.put('[data-picker-status]',message); this.querySelector('[data-picker-status]').hidden=!message;
      this.querySelector('[data-picker-review]').hidden=!review;
    }
    setupSticky() {
      if (!('IntersectionObserver' in window)) return;
      this.cartOpen=false;
      const update=()=>{
        const show=this.getBoundingClientRect().bottom<0 && !this.cartOpen && !this.dialog.open;
        this.querySelector('[data-pair-sticky]').hidden=!show;
        document.body.classList.toggle('bam-pair-mobile-space',show);
      };
      this.observer=new IntersectionObserver(update,{threshold:0}); this.observer.observe(this);
      window.addEventListener('scroll',update,{passive:true,signal:this.abort.signal});
      window.addEventListener('resize',update,{passive:true,signal:this.abort.signal});
      const bind=()=>{
        if (typeof window.upcartSubscribeCartOpened==='function' && !this.cartSubscribed) {
          this.cartSubscribed=true;
          window.upcartSubscribeCartOpened(()=>{this.cartOpen=true;update();});
          window.upcartSubscribeCartClosed?.(()=>{this.cartOpen=false;update();});
        }
      };
      bind(); window.addEventListener('load',bind,{once:true,signal:this.abort.signal});
    }
    async revealCart() {
      if (typeof window.upcartOpenCart==='function') {
        try {
          if (typeof window.upcartRefreshCart==='function') await Promise.race([Promise.resolve(window.upcartRefreshCart()),new Promise(resolve=>setTimeout(resolve,4000))]);
          window.upcartOpenCart(); this.cartOpen=true; this.querySelector('[data-pair-sticky]').hidden=true; return;
        } catch (_) {}
      }
      window.location.assign(this.config.cartUrl);
    }
    async addPair() {
      if (this.busy || this.uncertain) return;
      this.syncPrimary();
      const bundle=this.bundle();
      if (!bundle.valid) {
        if (!this.primaryVariant?.available) return;
        this.openPicker(!this.partnerVariant?.available ? 2 : 3,this.querySelector('[data-pair-add]'));
        return;
      }
      this.busy=true; this.status('');
      const controls=new Set([...this.querySelectorAll('button,input,select'),...this.scope.querySelectorAll('select.js-variant-selector,.js-variant-selector input,.js-variant-selector select,.js-ajax-submit')]);
      const disabledStates=new Map([...controls].map(el=>[el,el.disabled]));
      controls.forEach(el=>{el.disabled=true;});
      if(this.singleButton)this.singleButton.disabled=true;
      this.renderPrices();
      const quantities=new Map();
      bundle.entries.forEach(({variant})=>quantities.set(variant.id,(quantities.get(variant.id) || 0)+1));
      const items=[...quantities].map(([id,quantity])=>({id,quantity}));
      const controller=new AbortController(); const timer=setTimeout(()=>controller.abort(),20000);
      let accepted=false;
      try {
        const response=await fetch(this.config.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:controller.signal});
        if (!response.ok) {
          this.uncertain=true;
          this.status(this.t('cart_error'),true);
          return;
        }
        accepted=true;
        this.status(this.t('added'),true);
        document.dispatchEvent(new CustomEvent('bam:pair-added',{detail:{productIds:bundle.entries.map(entry=>entry.product.id),variantIds:items.map(item=>item.id),quantity:bundle.count}}));
        this.closePicker(true);
        await this.revealCart();
      } catch (_) {
        if (accepted) { this.status(this.t('added'),true); }
        else { this.uncertain=true;this.status(this.t('network_error'),true); }
      } finally {
        clearTimeout(timer); this.busy=false;
        disabledStates.forEach((disabled,el)=>{el.disabled=disabled;});
        this.renderPrices();
      }
    }
  }
  customElements.define('bam-tee-pair',BamTeePair);
})();
  } catch(e) { console.error(e); }
})();

})();
